import { Injectable } from '@angular/core';
import { IUserDetails } from '@irb/app.model';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { AppService } from '@irb/app.service';
import { delay, tap } from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import { ISchedule, IResponseObject, IScheduledDropdownList, IRefreshAsync, IDeleteSchdRebalance, IChangeOwner, ISelectAllResponse } from './scheduled.model';
import { IResultIdSet, IProcessNowResponse } from '@irb/irb-rebalance/scheduled/scheduled.model';
import {IPortfolioExportRequest} from "@irb/irb-clients/irb-clients.model";
@Injectable({
  providedIn: 'root'
})
export class ScheduledService {

  private userDetails: IUserDetails;
  filterCriteria: string = '';
  sortCriteria: string;

  constructor(private readonly http: HttpClient, private appService: AppService) {
    this.getUserDetails();
  }

  getUserDetails(): void {
    this.appService.getUserDetails().subscribe((res: IUserDetails) => {
        if(res) {
          this.userDetails = res;
        }
    });
  }

  getScheduleRebalanceInv(params: any): Observable<HttpResponse<ISchedule[]>> {
    const headers = new HttpHeaders({
      'X-HTTP-Method-Override':'GET',
      'Filter-Item':'items=' + params.request.startRow + '-' + (--params.request.endRow)
    });
    let sort = '';
    let filterKeys = '';
   
    if (params.request.filterModel && params.request.filterModel['analysisName']) {
      filterKeys = filterKeys + '%26analysisName%3D' + encodeURIComponent(params.request.filterModel['analysisName'].filter);
     } 

    if (params.request.filterModel && params.request.filterModel['analysisType']) {
      let analysisType: Array<String> = [];
     
      params.request.filterModel['analysisType'].values.forEach((type: any) => {
                (type === "Full rebalance") ? analysisType.push('Fully rebalance securities'):analysisType.push(type);
      });  
        filterKeys = filterKeys + '%26analysisType%3D' + analysisType;   
     }

    if (params.request.filterModel && params.request.filterModel['analysisCreatedBy']) {
      filterKeys = filterKeys + '%26analysisCreatedBy%3D' +params.request.filterModel['analysisCreatedBy'].values;
    } 

    if (params.request.filterModel && params.request.filterModel['portfolioName']) {
      filterKeys = filterKeys + '%26portfolioName%3D' + encodeURIComponent(params.request.filterModel['portfolioName'].filter);
    } 

     if (params.request.sortModel.length > 0) {
      const sortColumn = params.request.sortModel[0].colId;
      const sortOrder = (params.request.sortModel[0].sort === 'asc') ? '+' : '-';
      sort= '&sort(' + sortOrder + sortColumn + ')';
      this.sortCriteria = sort;
    }
    
    if (filterKeys) {
      this.filterCriteria = '&Filter=' + filterKeys;
     }

    return this.http.post<ISchedule[]>('/irebalone/rebalance-portfolios/analysis-inv'+ '?' + sort   ,{Filter:filterKeys},
           { headers: headers, observe: 'response' })
            .pipe(delay(1000), tap(_res => {
               //console.log(res.headers.get('Filter-Count'));
            })
        );
   }

  clearCriteria() {
    this.filterCriteria ='';
    this.sortCriteria ='';
  }
  getScheduledRebalanceCount(): Observable<IResponseObject> {
    return this.http.get<IResponseObject>('/irebalone/rebalance-portfolios/get-inv-count').pipe(delay(500));
  }

  getComboDropDownType(): Observable<IResponseObject> {
    return this.http.get<IResponseObject>('/irebalone/rebalance-portfolios/analysis-types-drop-down').pipe(delay(1000));  
  }
 
  getComboDropDownOwner(): Observable<IScheduledDropdownList> {
    return this.http.get<IScheduledDropdownList>('/irebalone/rebalance-portfolios/scheduled-by').pipe(delay(500));
  }

  refreshScheduledRebalance(): Observable<IRefreshAsync> {
    return this.http.post<IRefreshAsync>('/irebalone/rebalance-portfolios/refresh-portfolio-rebalance-data-async',null).pipe(delay(1000));
  }

  getRefreshScheduledRebalanceStatus(rasId: string): Observable<Object> {
    return this.http.get("/irebalone/rebalance-portfolios/refresh-portfolio-rebalance-data-status/" + rasId);
  }

  deleteScheduledRebalance(scheduledRebalances:IDeleteSchdRebalance[]): Observable<IResponseObject> {
      return this.http.post<IResponseObject>('/irebalone/rebalance-portfolios/delete', scheduledRebalances);
  }

  processScheduledRebalance(scheduledRebalances:IResultIdSet): Observable<IProcessNowResponse> {
    return this.http.post<IProcessNowResponse>('/irebalone/rebalance-portfolios/process-now',scheduledRebalances);
  }

  getSelectedSchdRebalanceIds(data:number[]): Observable<ISelectAllResponse> {
         return this.http.post<ISelectAllResponse>('/irebalone/rebalance-portfolios/get-ids-by-filter-criteria' + '?' + this.filterCriteria, data);
  }
  
  changeOwnerSchdRebalance(data: IChangeOwner): Observable<IResponseObject> {
    return this.http.post<IResponseObject>('/irebalone/rebalance-portfolios/change-owner', data);
   }
    getSelectAllScheduledRebalances(data: IPortfolioExportRequest): Observable<any> {
        let httpOptions = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            })
        };
        data.filter = decodeURIComponent(this.filterCriteria !== undefined ? this.filterCriteria : '');
        data.sort = decodeURIComponent( this.sortCriteria !== undefined ? this.sortCriteria : '');
        return this.http.post('/irebalone/rebalance-portfolios/get-details-by-filter', JSON.stringify(data), httpOptions);
    }

    deleteScheduledRebalanceAsync(scheduledRebalances:IDeleteSchdRebalance[]): Observable<IResponseObject> {
        return this.http.post<IResponseObject>('/irebalone/rebalance-portfolios/delete-async', scheduledRebalances);
        // const res: any = {
        //     "responseStatus": "SUCCESS",
        //     "responseData": null,
        //     "responseUtilityMap": {
        //         "reqStatus": "STARTED",
        //         "actionStatusId": 13209616
        //     }
        // }
        //return of(resp);
    }

    actionStatusCheck(actionStatusId: any) {
        return this.http.get('/irebalone/rebalance-portfolios/rebalance-status/' + actionStatusId);
        // false && console.log(actionStatusId);
        // return of({
        //         //          "status": "completed",
        //         //          "submittedCount": 1,
        //         //          "completedCount": 0,
        //         //          "failedCount": 0
        //         //     });
    }

}
